import { ReactNode, FC } from 'react';
import Link from 'next/link';
import { isValidUrl } from 'lib/isValidUrl';
import { getCommunityPath } from 'lib/community';

type TagLinkProps = {
  children?: ReactNode;
  className?: string;
};

const TagLinks: FC<TagLinkProps> = ({ children, className }) => {
  const rule = /([#][\w]+)/g;

  /**
   * Renders a string, add <br /> tags at every new line.
   * @param value String we want to display
   */
  function renderString(value: string) {
    const parts = value.split('\n');
    const output = [];

    for (let i = 0; i < parts.length; i++) {
      output.push(parts[i]);
      output.push(<br key={i} />);
    }

    return output.slice(0, -1);
  }

  function parse(description: string | string[] | any, index?: number): any {
    if (Array.isArray(description)) {
      return description.map(parse);
    } else if (description?.type === 'a') {
      const href = description.props.href;
      const text = description.props.children;
      if (isValidUrl(href) && typeof text === 'string') {
        return (
          <a key={index ?? text} href={href} target="_blank">
            {text}
          </a>
        );
      }
      return null;
    } else {
      return (description as string).split(rule).map((chunk: string) => {
        return chunk.match(rule) ? (
          <Link
            key={chunk}
            href={getCommunityPath(`tag/${chunk.replace('#', '')}/`)}
          >
            {chunk}
          </Link>
        ) : (
          renderString(chunk)
        );
      });
    }
  }
  return <span className={className}>{parse(children as string)}</span>;
};

export default TagLinks;
